import translation from 'locales/translation';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import AssembleiaDocs from 'components/__ASSOCIADO__/AssembleiaDocs';
import GenericModal, {
  IGenericModalProps,
} from 'components/Modal/__LEGACY__/GenericModal/GenericModal';

import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from 'store/modules/ModalsReducer';

export interface IAssembleiaDocsModalGenericProps extends IGenericModalProps {
  key: string;
}

export interface IAssembleiaDocsModal extends IModalProps {
  genericProps?: IAssembleiaDocsModalGenericProps;
}

export default function AssembleiaDocsModal({
  genericProps,
  open,
}: IAssembleiaDocsModal) {
  const dispatch = useDispatch();

  const toClose = useCallback(() => {
    if (genericProps?.key) {
      dispatch(modalsActionsClose(genericProps.key));
    }
  }, [dispatch, genericProps]);

  return (
    <GenericModal
      open={open ?? false}
      title={translation.AssembleiaDocsModal.title}
      content={<AssembleiaDocs />}
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
      }}
    />
  );
}
